import { forwardRef } from "react";

import { useTheme } from "@mui/material";

import { FormIcon, FormIconProps } from "@/forms-design-system/FormIcon/FormIcon";
import { FormTooltip, FormTooltipProps } from "@/forms-design-system/FormTooltip/FormTooltip";
import { InvalidThemeErrorMessage } from "@/forms-design-system/InvalidThemeErrorMessage";
import { mergeSx } from "@/helpers/mergeSx";
import { Info } from "@/icons/outlined";

type FormInfoTooltipProps = Pick<FormTooltipProps, "title" | "components" | "placement"> &
  Omit<FormIconProps, "children" | "title">;

export const FormInfoTooltip = forwardRef<HTMLDivElement, FormInfoTooltipProps>(
  ({ title, placement = "top-end", components, size = "small", sx, ...rest }, ref) => {
    const theme = useTheme();

    if (!theme.palette.forms || !theme.palette.formsComponents?.tooltip) {
      return <InvalidThemeErrorMessage />;
    }

    const iconStyles = mergeSx(
      {
        display: "inline-block",
        color: theme.palette.formsComponents?.tooltip.iconColor,
        cursor: "help",
      },
      sx
    );

    return (
      <FormTooltip title={title} components={components} placement={placement}>
        <FormIcon ref={ref} size={size} sx={iconStyles} tabIndex={0} {...rest}>
          <Info />
        </FormIcon>
      </FormTooltip>
    );
  }
);

FormInfoTooltip.displayName = "FormInfoTooltip";
